import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import { Link as MaterialLink } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { Link } from 'react-router-dom'

import { Copyright } from '..'
import { resetPassword } from 'daily-dose-common'
import { useDispatch, useSelector } from 'react-redux'
import { openSnackbar } from '../../ducks/snackbar/actions'
import { IStoreState } from '../../store/types'
import { asyncError, asyncFinish, asyncStart } from '../../ducks/ui/actions'

// TODO: TextField aren ot longer supported according to Google Material Design so this needs to be refactor
// https://medium.com/google-design/the-evolution-of-material-designs-text-fields-603688b3fe03
//TODO: Implement forget password

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
  submitWithGoogle: {
    margin: theme.spacing(0, 0, 2),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

const ForgotPassword = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const ui = useSelector((state: IStoreState) => state.ui)

  const [email, setEmail] = useState('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!!email) {
      try {
        dispatch(asyncStart('USER-FORGOT-PASSWORD'))
        await resetPassword(email)

        dispatch(asyncFinish('USER-FORGOT-PASSWORD-EMAIL-SENT'))
        dispatch(
          openSnackbar(
            'Check your email for further instructions on how to reset your password',
            'success'
          )
        )
      } catch (error) {
        console.warn('error ', error)
        setEmail('')
        dispatch(
          asyncError(
            error.message ||
              'We could not reset the password. Check that the email is valid'
          )
        )
      }
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="header" variant="h3">
          Forgot password
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            value={email}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            error={!!ui.error && !email}
            helperText={ui.error}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={ui.loading}
          >
            Forgot password
          </Button>

          <Grid container>
            <Grid item xs>
              <MaterialLink variant="body2" component={Link} to="sign-up">
                {"Don't have an account? Sign Up"}
              </MaterialLink>
            </Grid>
            <Grid item>
              <MaterialLink variant="body2" component={Link} to="sign-in">
                Login
              </MaterialLink>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}

export default ForgotPassword
